/* eslint-disable no-console */
import { captureException, captureMessage, Severity } from '@sentry/vue'

export function logWarning(message: string): void {
  captureMessage(message, Severity.Warning)
  console.warn(message)
}

export function logException(e: unknown): void {
  if (typeof e === 'string') {
    captureMessage(e, Severity.Error)
    console.error(e)
  } else {
    captureException(e)
    console.error(e)
  }
}
